import styled, { ISpruceThemeProps } from 'styled-components';

type SpaceType = 'default' | 'roomy' | 'none';

export interface ISpaceWrapper {
  topSpace?: SpaceType;
  rightSpace?: SpaceType;
  bottomSpace?: SpaceType;
  leftSpace?: SpaceType;
}

const convertSpaceTypeToSpacing = ({ theme }: ISpruceThemeProps, spaceType?: SpaceType): string => {
  switch (spaceType) {
    case 'default':
      return theme.spacing.spacing4;
    case 'none':
      return '0';
    case 'roomy':
    default:
      return theme.spacing.spacing5;
  }
};

export const SpaceWrapper = styled.div<ISpaceWrapper>`
  padding: ${(props) => convertSpaceTypeToSpacing(props, props.topSpace)}
    ${(props) => convertSpaceTypeToSpacing(props, props.rightSpace)}
    ${(props) => convertSpaceTypeToSpacing(props, props.bottomSpace)}
    ${(props) => convertSpaceTypeToSpacing(props, props.leftSpace)};
`;
